import axios from 'axios';

export interface CandidaturaHistorico {
  id: string;
  candidato_id: string;
  ciclo: number;
  cargo: string;
  numero_urna: string;
  partido: string;
  /** Total declarado na apuração oficial do ciclo. */
  votos: number;
  resultado: 'eleito' | 'nao_eleito' | 'suplente';
  /** Soma dos resultados por zona carregados na base. */
  votos_apurados: number;
  zonas: number;
}

export interface CandidatoHistorico {
  id: string;
  nome: string;
  uf: string;
  municipio: string;
  candidaturas: CandidaturaHistorico[];
  total_ciclos: number;
  melhor_resultado?: string;
}

export interface ResultadoZona {
  id: string;
  ciclo: number;
  cargo: string;
  zona: string;
  secao?: string;
  candidato_id: string;
  votos: number;
}

const API_URL = import.meta.env.VITE_API_URL || '/api';
const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const candidatosApi = {
  list: async (token: string, filtros?: { uf?: string; municipio?: string }) => {
    const res = await axios.get<CandidatoHistorico[]>(`${API_URL}/eleg/candidatos`, {
      ...auth(token),
      params: filtros,
    });
    return res.data;
  },

  get: async (id: string, token: string) => {
    const res = await axios.get<CandidatoHistorico>(`${API_URL}/eleg/candidatos/${id}`, auth(token));
    return res.data;
  },

  resultadosPorZona: async (ciclo: number, token: string, cargo?: string) => {
    const res = await axios.get<ResultadoZona[]>(`${API_URL}/eleg/candidatos/resultados`, {
      ...auth(token),
      params: { ciclo, cargo },
    });
    return res.data;
  },
};
